<template>
    <div style="overflow: hidden;">
        <tool-bar title="third" url="/repayment_methods"></tool-bar>
        <div class="h-line-E6E8EB"></div>
        <iframe style="position:fixed;width:100%;height: 100%;top: 55px;"
                :src="url"
                frameborder="0"
                scrolling="yes"
                marginheight="55px"
                id="bdIframe">
        </iframe>
    </div>
</template>

<script>

    export default {
        name: "third_page",
        data() {
            return {
                url: ''
            }
        },
        mounted() {
            /**
             * iframe-宽高自适应显示
             */
            const oIframe = document.getElementById('bdIframe');
            const deviceWidth = document.documentElement.clientWidth;
            const deviceHeight = document.documentElement.clientHeight;
            oIframe.style.width = deviceWidth + 'px';
            oIframe.style.height = deviceHeight + 'px';
            this.url = this.$route.query.url
        },
    }
</script>

<style scoped>

</style>